import { PuzzleGameModel } from './puzzle-game.model';
import { PuzzleGameStateBaseModel } from '../puzzle-framework-module/puzzle-game-state-base.model';

export enum LetterOverwriteRestrictions {
  None = 'none',
  All = 'all',
  CorrectLetters = 'correct_letters',
  CorrectWords = 'correct_words',
}

export enum LetterDeleteRestrictions {
  None = 'none',
  CompletedWords = 'completed_words',
  CorrectLetters = 'correct_letters',
  CorrectWords = 'correct_words',
}

export enum WordJumpOnRestrictions {
  None = 'none',
  CompleteWord = 'complete_word',
  CorrectWord = 'correct_word',
}

export enum WordJumpToRestrictions {
  Any = 'any',
  IncompleteWord = 'incomplete_word',
  IncorrectWord = 'incorrect_word',
}

export enum DarkModes {
  System = 'system',
  Dark = 'dark',
  Light = 'light',
}

export interface PuzzleGameStateModel extends PuzzleGameStateBaseModel {
  puzzleGames: { [puzzleID: string]: PuzzleGameModel };
  paused: number;
  difficulty?: string;
  language?: string;

  autoZoomEnabled?: boolean;
  definitionBarEnabled?: boolean;
  nativeKeyboard?: boolean;
  keepKeyboardOpen?: boolean;

  letterOverwriteRestriction?: LetterOverwriteRestrictions;
  letterDeleteRestriction?: LetterDeleteRestrictions;

  wordJumpOnRestriction?: WordJumpOnRestrictions;
  wordJumpToRestriction?: WordJumpToRestrictions;

  highlightRightAndWrongEnabled?: boolean;
  showErrorsImmediately?: boolean;

  highContrastEnabled?: boolean;
  darkMode?: DarkModes;
}
